import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Tabs } from '@vwfs-bronson/bronson-react';
import { dashboardTabs } from '../../../../resources/base/models';
import { DealerDashboardSubpage } from '../../../../resources/base/models/enums';
import { setSubPageLabelStatusIds } from '../../../../services/redux/features/dashboard.slice';
import { useNavigate } from '../../../../services/routing/navigate';

export const DashboardSubpagesTabs: FunctionComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const tabsList = dashboardTabs;
  const currentPath: string = window.location.pathname;

  const fallback = DealerDashboardSubpage.Summary;
  const selectedSubpage: DealerDashboardSubpage =
    (Object.keys(tabsList).find((dealerDashboardSubpage) =>
      currentPath.startsWith(tabsList[dealerDashboardSubpage].link)
    ) as DealerDashboardSubpage) ?? fallback;

  const navigateToSubpage = async (link: string) => {
    dispatch(setSubPageLabelStatusIds(undefined));
    navigate.url(link);
  };

  return (
    <Tabs defaultSelected={selectedSubpage}>
      <Tabs.Header>
        {Object.entries(tabsList).map(([dealerDashboardSubpage, { link }]) => (
          <Tabs.HeaderItem
            key={dealerDashboardSubpage}
            tabId={dealerDashboardSubpage}
            onClick={() => navigateToSubpage(link)}
          >
            {t(`dashboard:${link.split('/').pop()}:title`)}
          </Tabs.HeaderItem>
        ))}
      </Tabs.Header>
    </Tabs>
  );
};
